import { Divider, Grid, Typography } from '@material-ui/core';
import RoleSelect from 'App/Vehicles/shared/RoleSelect';
import React from 'react';

import UserCustomer from './UserCustomer';

export default function UserRole() {
  return (
    <>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography color="textSecondary" variant="body2">
          <strong>Ylläpitäjä</strong> voi tehdä mitä vain hallintajärjestelmässä
        </Typography>

        <Typography color="textSecondary" variant="body2">
          <strong>Työntekijä</strong> voi tehdä huoltoja mobiilisovelluksella
        </Typography>
        <br />

        <Typography color="textSecondary" variant="body2">
          <strong>Asiakkaan pääkäyttäjä</strong> näkee omat tiedot
          mobiilisovelluksessa
        </Typography>

        <Typography color="textSecondary" variant="body2">
          <strong>Asiakkaan työntekijä</strong> voi tehdä huoltoja
          yksinkertaistetusti mobiilisovelluksella
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <RoleSelect name="user.role_id" />
      </Grid>

      <Grid item xs={6}>
        <UserCustomer />
      </Grid>
    </>
  );
}
